<template>
  <div class="card-with-header-wrapper">
    <v-card class="card-with-header" :class="{ 'card-with-header--light': isLight }">
      <v-card-title
        class="card-header text-center pa-3"
        :class="isLight ? 'card-header--light' : 'primary white--text'">
        {{ title }}
      </v-card-title>
      <v-card-text class="card-body pa-4 px-8">
        <div class="content-icon-container">
          <div class="conteudo" :class="isLight ? 'conteudo--light' : 'primary--text'">
            <slot name="content">
              {{ content }}
            </slot>
          </div>
          <div class="icone" v-if="icon">
            <v-icon
              :class="isLight ? 'icone--light' : `${iconColor}--text`"
              :style="{ fontSize: `${iconSize}px` }">
              {{ icon }}
            </v-icon>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <div
      v-if="hasHint"
      class="card-hint"
      :class="isLight ? 'card-hint--light' : 'card-hint--dark'">
      <p class="card-hint__title">{{ title }}</p>
      <p class="card-hint__text">
        <strong>{{ $t('label.regra_calculo') }}:</strong>
        {{ hintRegra }}
      </p>
      <p class="card-hint__text mb-0">
        <strong>{{ $t('label.referencias_de_data') }}:</strong>
        {{ hintReferencia }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardWithHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    iconSize: {
      type: [String, Number],
      default: 38,
    },
    iconColor: {
      type: String,
      default: 'primary',
    },
    variant: {
      type: String,
      default: 'dark',
    },
    hintRegra: {
      type: String,
      default: '',
    },
    hintReferencia: {
      type: String,
      default: '',
    },
  },
  computed: {
    isLight() {
      return this.variant === 'light';
    },
    hasHint() {
      return !!(this.hintRegra || this.hintReferencia);
    },
  },
};
</script>

<style scoped>
.card-with-header {
  border-radius: 12px 12px 4px 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: transparent !important;
}

.card-header {
  border-radius: 12px 12px 0 0;
}

.card-body {
  border-radius: 0 0 4px 4px;
  background-color: #ffffff;
}

.card-with-header >>> .v-card__title {
  justify-content: center;
  text-align: center;
  width: 100%;
}

.content-icon-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.conteudo {
  font-size: 20px;
  font-weight: bold;
  flex: 1;
}

.icone {
  margin-left: 16px;
  opacity: 0.8;
  display: flex;
  align-items: center;
}

.icone >>> .v-icon {
  -webkit-text-stroke: 1px currentColor;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
}

.card-header--light {
  background-color: #D0EAF8;
  color: #1B3A5F;
  font-weight: 700;
}

.conteudo--light {
  color: #4BA3D1;
}

.icone--light {
  color: #4BA3D1 !important;
}

.card-with-header-wrapper {
  position: relative;
  flex: 1;
  z-index: 1;
}

.card-with-header-wrapper:hover {
  z-index: 30;
}

.card-hint {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 20;
  border-radius: 8px;
  padding: 12px 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.card-with-header-wrapper:hover .card-hint {
  display: block;
}

.card-hint--dark {
  background-color: #1B5499;
  color: #ffffff;
}

.card-hint--light {
  background-color: #D0EAF8;
  color: #1B3A5F;
}

.card-hint__title {
  font-weight: 700;
  text-align: center;
  margin: 0 0 10px;
}

.card-hint__text {
  font-size: 13px;
  line-height: 1.35;
  margin: 0 0 10px;
  text-align: left;
}
</style>
